export default "__VITE_ASSET__CrnZUYaM__"